import { useStore } from '@/store'
import { createFileRoute } from '@tanstack/react-router'
import { useShallow } from 'zustand/shallow'

export const Route = createFileRoute('/paytm/profile')({
    component: RouteComponent,
})

function RouteComponent() {
    const { email, phone, selectedAccount, accountIds, role, clearAuth } = useStore(useShallow(state => ({
        email: state.email,
        phone: state.phoneNumber,
        selectedAccount: state.selectedAccount.id,
        accountIds: state.accountIds,
        role: state.selectedAccount.role,
        clearAuth: state.clearAuth
    })))

    return <div className='w-full'>
        <div className="p-4">
            <table className="border-collapse border [&_td]:border [&_td]:p-2 text-sm">
                <tr>
                    <td>Email</td>
                    <td>{email}</td>
                </tr>
                <tr>
                    <td>Phone</td>
                    <td>{phone}</td>
                </tr>
                <tr>
                    <td>Selected Account</td>
                    <td>{selectedAccount}</td>
                </tr>
                <tr>
                    <td>Account Ids</td>
                    <td>
                        <ul>
                            {accountIds.map(id => <li key={id}>{id}</li>)}
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td>Role</td>
                    <td>{role}</td>
                </tr>
                <tr>
                    <td>URL</td>
                    <td><input value={window.location.href} readOnly className='w-full'/></td>
                </tr>
            </table>
        </div>
        <div className="flex gap-6 p-4">
            {accountIds.filter(e => e.includes('mp2')).length > 0 && window.location.href.includes('https://app.mp2.in') ?
                <p className="cursor-pointer text-white bg-blue-500 font-semibold px-3 py-2 border rounded-lg active:opacity-30" onClick={() => window.location.assign('https://preprod-app.prorouting.in/paytm/neworder')} >Switch to Preprod</p> : null}
            <p className="cursor-pointer text-white bg-red-500 font-semibold px-3 py-2 border rounded-lg active:opacity-30" onClick={() => clearAuth()}>Logout</p>
        </div>
    </div>
}
